export default __webpack_public_path__ + "static/spacer-w--gorach--30-23cd58fe0b7d7770be6d0db094521962.jpg";